import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Session } from '../api/client'

type AuthState = {
  session: Session | null
  setSession: (s: Session | null) => void
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
    }),
    { name: 'bskydisc.auth' },
  ),
)
